import { WiseOwlIngress } from "../types";
import { getOscConfig } from "./oneSupportCenterEnv/oneSupportCenterEnv";
import { wiseOwlZendeskAppHostByRealm } from "./wiseOwlApi";

const { supportApiEndpoint, supportAuthorizerEndpoint } = getOscConfig();

const routes = {
  liveChat: "/live-chats",
  surveys: "/surveys",
};

export const helpCenterApiDomain = {
  local: "http://localhost:17825/v1",
  dev: "https://help-center.aws-otk-dev-general-use1-001.otk.twilioinfra.com/v1",
  stage:
    "https://help-center.aws-otk-stage-general-use1-001.otk.twilioinfra.com/v1",
  prod: "https://help-center.aws-otk-prod-general-use1-001.otk.twilioinfra.com/v1",
};

export const helpCenterApiRootByZendeskHost = {
  // [wiseOwlZendeskAppHostByRealm.local]: helpCenterApiDomain.local,
  [wiseOwlZendeskAppHostByRealm.local]: helpCenterApiDomain.dev,
  [wiseOwlZendeskAppHostByRealm.sandbox]: helpCenterApiDomain.stage,
  [wiseOwlZendeskAppHostByRealm.prod]: helpCenterApiDomain.prod,
};

export const getHelpCenterSalesforceServiceEndpoint = (): string => {
  // TODO: Update with logic to determine HelpCenter Salesforce service endpoint
  return helpCenterApiDomain.prod;
};

export const getHelpCenterWiseOwlAppServiceEndpoint = (): string => {
  // TODO: Update with logic to determine HelpCenter WiseOwlApp service endpoint
  return helpCenterApiDomain.prod;
};

export const getWozdHelpCenterApiEndpoint = () => {
  const serviceEndpoint =
    helpCenterApiRootByZendeskHost[window.location.host] ||
    helpCenterApiDomain.prod;

  return serviceEndpoint;
};

export const wiseOwlIngressToHelpCenterEndpointMap: Record<
  WiseOwlIngress,
  string
> = {
  // Runs through Stargate
  [WiseOwlIngress.osc]: `${supportApiEndpoint}/helpCenter`,
  [WiseOwlIngress.oscUngated]: `${supportApiEndpoint}/helpCenter`,
  [WiseOwlIngress.console]: `${supportApiEndpoint}/helpCenter`,
  // Can hit OTK directly
  [WiseOwlIngress.salesforce]: getHelpCenterSalesforceServiceEndpoint(),
  [WiseOwlIngress.zendesk]: getWozdHelpCenterApiEndpoint(),
  [WiseOwlIngress.wiseOwlApp]: getHelpCenterWiseOwlAppServiceEndpoint(),
  [WiseOwlIngress.sendGrid]: `${supportAuthorizerEndpoint}/helpCenter`,
};

export const helpCenterEndpoints = {
  createLiveChat: (): string => `${routes.liveChat}`,
  refreshLiveChatToken: (): string => `${routes.liveChat}/refreshToken`,
  getLiveChatMessages: (liveChatId: string): string =>
    `${routes.liveChat}/${liveChatId}`,
  endLiveChat: (liveChatId: string): string =>
    `${routes.liveChat}/${liveChatId}`,
  createSurveySession: (surveyId: string): string =>
    `${routes.surveys}/${surveyId}/sessions`,
  updateSurveySession: (surveyId: string, sessionId: string): string =>
    `${routes.surveys}/${surveyId}/sessions/${sessionId}`,
  getSurveyResponseReceipts: (): string => `${routes.surveys}`,
};

export const getHelpCenterApiServiceEndpoint = (ingress?: WiseOwlIngress) => {
  // Sendgrid, Salesforce, WiseOwlApp, and Zendesk apps can hit OTK directly
  if (
    ingress === WiseOwlIngress.wiseOwlApp ||
    ingress === WiseOwlIngress.salesforce ||
    ingress === WiseOwlIngress.zendesk ||
    ingress === WiseOwlIngress.sendGrid
  ) {
    return wiseOwlIngressToHelpCenterEndpointMap[ingress];
  }

  return `${supportApiEndpoint}/helpCenter`;
};
